import { useIntl } from 'react-intl'

export const TermOfParticipation = () => {
  const { formatMessage } = useIntl()

  return (
    <div className="flex flex-col grow items-center">
      <section className="flex flex-col grow pt-4 md:pt-14 pb-10 text-black text-justify max-w-6xl">
        <h1 className="font-openSans mb-16 text-[40px] font-bold text-[#001D2F] uppercase mx-auto text-center">{formatMessage({ id: 'TRUST_INSIGHT_TERMS_OF_PARTICIPATION' })}</h1>

        <div className="mb-[100px] whitespace-pre-line text-base font-medium text-[#39393A]">
          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_1" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_1' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_1' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_2" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_2' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_2' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_3" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_3' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_3' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_4" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_4' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_A' })}</span>

          <ul className="list-disc list-inside mt-6 mb-6">
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_B' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_C' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_D' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_E' })}</span>
            </li>
            <li>
              <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_F' })}</span>
            </li>
          </ul>

          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_4_G' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_5" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_5' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_5' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_6" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_6' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_6' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_7" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_7' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_7' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_8" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_8' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_8' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_9" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_9' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_9' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_10" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_10' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_10' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_11" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_11' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_11' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_12" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_12' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_12' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_13" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_13' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_13' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_14" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_14' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_14' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_15" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_15' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_15' })}</span>

          <h2 id="TERMS_OF_PARTICIPATION_SUBTITLE_16" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'TERMS_OF_PARTICIPATION_SUBTITLE_16' })}</h2>
          <span>{formatMessage({ id: 'TERMS_OF_PARTICIPATION_TEXT_16' })}</span>

        </div>
      </section>
    </div>
  )
}
